import "./app_event_logs.scss";

let appEventLogsComponent = {
  restrict: "E",
  bindings: {},
};

export default appEventLogsComponent;



// WEBPACK FOOTER //
// ./client/app/components/app_event_logs/app_event_logs.component.js